import { render, staticRenderFns } from "./PendingProductUpdateDialog.vue?vue&type=template&id=423a3b2f"
import script from "./PendingProductUpdateDialog.vue?vue&type=script&lang=js"
export * from "./PendingProductUpdateDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports